import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
	addPublicHoliday,
	deletePublicHoliday,
	getPublicHoliday,
	updatePublicHoliday,
} from '../../../services/services';

export const addHoliday = createAsyncThunk('addHoliday', async (data, thunkAPI) => {
	try {
		const response = await addPublicHoliday(data);
		return response?.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error);
	}
});

export const getHolidays = createAsyncThunk('getHoliday', async (_, thunkAPI) => {
	try {
		const response = await getPublicHoliday();
		return response?.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error);
	}
});

export const updateHolidays = createAsyncThunk('updateHoliday', async (credentials, thunkAPI) => {
	try {
		const { id, ...data } = credentials;
		const response = await updatePublicHoliday(id, data);
		return response?.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error);
	}
});

export const deleteHolidays = createAsyncThunk('deleteHoliday', async (id, thunkAPI) => {
	try {
		const response = await deletePublicHoliday(id);
		return response?.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error);
	}
});

const holidaySlice = createSlice({
	name: 'holidaySlice',
	initialState: {
		holidays: null,
		addedHoliday: null,
		error: null,
		isLoading: false,
		updateHoliday: null,
		destroyHoliday: null,
	},
	reducers: {
		resetHolidayState: (state) => {
			state.holidays = null;
			state.isLoading = false;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(addHoliday.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(addHoliday.fulfilled, (state, action) => {
				state.isLoading = false;
				state.addedHoliday = action.payload;
				state.error = null;
			})
			.addCase(addHoliday.rejected, (state, action) => {
				state.isLoading = false;
				state.addedHoliday = null;
				state.error = action.payload;
			})

			// listAllHolidays
			.addCase(getHolidays.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(getHolidays.fulfilled, (state, action) => {
				state.isLoading = false;
				state.holidays = action.payload;
				state.error = null;
			})
			.addCase(getHolidays.rejected, (state, action) => {
				state.isLoading = false;
				state.holidays = null;
				state.error = action.payload;
			})

			//updateHoliday
			.addCase(updateHolidays.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(updateHolidays.fulfilled, (state, action) => {
				state.isLoading = false;
				state.updateHoliday = action.payload;
				state.error = null;
			})
			.addCase(updateHolidays.rejected, (state, action) => {
				state.isLoading = false;
				state.updateHoliday = null;
				state.error = action.payload;
			})

			//deleteHoliday
			.addCase(deleteHolidays.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(deleteHolidays.fulfilled, (state, action) => {
				state.isLoading = false;
				state.destroyHoliday = action.payload;
				state.error = null;
			})
			.addCase(deleteHolidays.rejected, (state, action) => {
				state.isLoading = false;
				state.destroyHoliday = null;
				state.error = action.payload;
			});
	},
});

export const { resetHolidayState } = holidaySlice.actions;
export default holidaySlice.reducer;
